import { render, staticRenderFns } from "./selectMissingWords.vue?vue&type=template&id=6cd7b8ec&scoped=true&"
import script from "./selectMissingWords.vue?vue&type=script&lang=js&"
export * from "./selectMissingWords.vue?vue&type=script&lang=js&"
import style0 from "./selectMissingWords.vue?vue&type=style&index=0&id=6cd7b8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd7b8ec",
  null
  
)

export default component.exports